import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: { defaultMessage: 'Please wait' },
  description: { defaultMessage: 'We are loading something for you' },
});
